module.exports = __webpack_public_path__ + "img/713.e6fe3617.png";